import rolesConfig from '@/core/config/roles';
import { LocationState } from '@/router/guards/types';
import { AuthContext } from '@/shared/context/auth-context/AuthContext';
import { FunctionComponent, ReactElement, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const Home: FunctionComponent = (): ReactElement => {
	const { user } = useContext(AuthContext);
	const location = useLocation();
	/** Perform routing based on user's role */
	return (
		<Navigate to={rolesConfig[user!.role].indexRoute} state={location.state as LocationState} />
	);
};

export default Home;
